import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "./Home.module.css";

function ResetPassword() {
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  // 从 sessionStorage 中获取之前保存的邮箱
  const email = sessionStorage.getItem("resetEmail") || "";

  const handleResetPassword = async () => {
    if (!code || !newPassword) {
      setMessage("認証コードと新しいパスワードを入力してください。");
      return;
    }
    setMessage("送信中...");

    try {
      const res = await axios.post(
        "https://api.nagae.biz/api/reset-password",
        { email, code, new_password: newPassword },
        { headers: { "Content-Type": "application/json" } }
      );
      setMessage(res.data.message);
      // 密码重置成功后跳转到登录页
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    } catch (error) {
      if (error.response) {
        setMessage(error.response.data.detail || "エラーが発生しました。");
      } else {
        setMessage("サーバーに接続できません。");
      }
    }
  };

  return (
    <div className={styles.container}>
      <img src="" alt="背景画像" className={styles.backgroundImage} />
      <div className={styles.content}>
        <header className={styles.header}>
          <h1 className={styles.title}>パスワード再設定</h1>
        </header>
        <div className={styles.card}>
          <input
            type="text"
            className={styles.input}
            style={{
              width: "90%",
              padding: "12px",
              fontSize: "1rem",
              marginBottom: "20px",
            }}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="認証コード"
            required
          />
          <input
            type="password"
            className={styles.input}
            style={{
              width: "90%",
              padding: "12px",
              fontSize: "1rem",
              marginBottom: "50px",
            }}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="新しいパスワード"
            required
          />
          <button
            onClick={handleResetPassword}
            className={`${styles.btn} ${styles.btnPrimary}`}
          >
            パスワード再設定
          </button>
          <p className={styles.message}>{message}</p>
          <button
            onClick={() => navigate("/login")}
            className={`${styles.btn} ${styles.btnSecondary}`}
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;
